import {
  LS_ACCESS_TOKEN,
  LS_DEVICE_ID,
  LS_LAST_SUPPORT_TIME,
  LS_LOCALE,
  LS_PLANNING_WEEK_MODE,
  LS_REFRESH_TOKEN
} from "../codes";

export const getLocale = () => localStorage.getItem(LS_LOCALE) || "fr";
export const setLocale = locale => localStorage.setItem(LS_LOCALE, locale);

export const getAccessToken = () => localStorage.getItem(LS_ACCESS_TOKEN);

export const setAccessToken = token => localStorage.setItem(LS_ACCESS_TOKEN, token);

export const removeAccessToken = () => localStorage.removeItem(LS_ACCESS_TOKEN);

export const getRefreshToken = () => localStorage.getItem(LS_REFRESH_TOKEN);

export const setRefreshToken = token => localStorage.setItem(LS_REFRESH_TOKEN, token);

export const getDeviceId = () => localStorage.getItem(LS_DEVICE_ID);

export const setDeviceId = deviceId => localStorage.setItem(LS_DEVICE_ID, deviceId);

export const getLastSupportTime = () => localStorage.getItem(LS_LAST_SUPPORT_TIME);

export const setLastSupportTime = time => localStorage.setItem(LS_LAST_SUPPORT_TIME, time);

export const getPlanningWeekMode = () => localStorage.getItem(LS_PLANNING_WEEK_MODE);

export const setPlanningWeekMode = mode => localStorage.setItem(LS_PLANNING_WEEK_MODE, mode);
